import media2 from "../assets/figma/media-2.png";
import { Container, SiteFooter, SiteHeader } from "./SiteChrome";
import { InquiryForm } from "./InquiryForm";
import { useCmsBatch } from "../hooks/useCmsBatch";
import { CmsIcon } from "../utils/cmsIcons";

const eventTypesDefault = [
  { icon: "Trophy", title: "Youth & adult leagues", body: "Organized competition across age groups and skill levels." },
  { icon: "CalendarDays", title: "Summer camps", body: "Full-day and half-day camps focused on skill-building and fun." },
  { icon: "Gift", title: "Birthday parties", body: "High-energy soccer parties planned and hosted by our team." },
  { icon: "Building2", title: "Corporate & group events", body: "Team-building and pickup sessions for groups of any size." },
];

const CMS_KEYS = ["events-hero", "events-types"];

export function EventsPage() {
  const { content } = useCmsBatch(CMS_KEYS);
  const hero = content["events-hero"] || {};
  const typesSection = content["events-types"] || {};
  const eventTypes = typesSection.items?.length ? typesSection.items : eventTypesDefault;

  return (
    <>
      <SiteHeader />
      <main>
        <section className="section dark">
          <Container className="grid-12">
            <div className="section-copy">
              <p className="eyebrow lime"><span>01</span>Camps & Events</p>
              <h2>{hero.title || "Play, compete, celebrate."}</h2>
              <p style={{ color: "var(--muted)", lineHeight: 1.8, marginTop: 16 }}>
                {hero.body || "From leagues and summer camps to birthday parties and corporate events, Formula Soccer Center hosts it all inside our premium turf arenas."}
              </p>
            </div>
            <div className="media-split-image">
              <img src={hero.mediaUrl || media2} alt="Players competing at Formula Soccer Center" />
            </div>
          </Container>
        </section>

        <section className="section light">
          <Container>
            <p className="eyebrow"><span>02</span>What we host</p>
            <h2 style={{ fontSize: "clamp(32px, 4vw, 52px)" }}>{typesSection.title || "Something for every occasion."}</h2>
            <div className="value-grid">
              {eventTypes.map((item) => (
                <div key={item.title} className="value-card">
                  <div className="value-card-icon"><CmsIcon name={item.icon} size={20} strokeWidth={1.5} /></div>
                  <h3>{item.title}</h3>
                  <p>{item.body}</p>
                </div>
              ))}
            </div>
          </Container>
        </section>

        <section className="section dark">
          <Container>
            <p className="eyebrow lime"><span>03</span>Plan your event</p>
            <h2 style={{ fontSize: "clamp(28px, 3.5vw, 42px)" }}>Let's plan it together.</h2>
            <InquiryForm
              source="event_inquiry"
              submitLabel="Request details"
              successMessage="Thanks! Our team will follow up to help plan your event."
              messagePlaceholder="Event type, date, and group size (optional)"
            />
          </Container>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
